// removed by extract-text-webpack-plugin
module.exports = {"gallery":"src-components-ScholarshipGallery----gallery-module---gallery---3lS8h","text":"src-components-ScholarshipGallery----gallery-module---text---3lgqt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ScholarshipGallery/gallery.module.css
// module id = 678
// module chunks = 165208297294940